import styled from 'styled-components'
import { darken } from 'polished'
import { RowBetween } from '../../components/Row'

// ========== 完全复用 CurrencyInputPanel 的输入框样式 ==========

export const InputPanel = styled.div`
  ${({ theme }) => theme.flexColumnNoWrap}
  position: relative;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.bg2};
  z-index: 1;
  margin-bottom: 6px;
`

export const Container = styled.div`
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.bg2};
  background-color: ${({ theme }) => theme.bg1};
`

export const LabelRow = styled.div`
  ${({ theme }) => theme.flexRowNoWrap}
  align-items: center;
  color: ${({ theme }) => theme.text1};
  font-size: 0.75rem;
  line-height: 1rem;
  padding: 0.5rem 0.75rem 0 0.75rem;
  span:hover {
    cursor: pointer;
    color: ${({ theme }) => darken(0.2, theme.text2)};
  }
`

export const InputRow = styled.div`
  ${({ theme }) => theme.flexRowNoWrap}
  align-items: center;
  padding: 0.5rem 0.75rem 0.5rem 0.75rem;
`

export const StyledBalanceMax = styled.button`
  height: 28px;
  background-color: ${({ theme }) => theme.primary5};
  border: 1px solid ${({ theme }) => theme.primary5};
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  margin-right: 0.5rem;
  color: ${({ theme }) => theme.primaryText1};
  :hover {
    border: 1px solid ${({ theme }) => theme.primary1};
  }
  :focus {
    border: 1px solid ${({ theme }) => theme.primary1};
    outline: none;
  }

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    margin-right: 0.5rem;
  `};
`

export const UnitLabel = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.text1};
  white-space: nowrap;
  margin-left: 4px;
`

// ========== 挂单页面其他样式 ==========

export const OrderWrapper = styled.div`
  width: 100%;
  padding: 0 0.75rem 0.75rem;
`

/** 买入/卖出：胶囊样式（原样式） */
export const TabRowPill = styled.div`
  display: flex;
  margin-bottom: 12px;
  border-radius: 10px;
  background: ${({ theme }) => theme.bg2};
  padding: 3px;
`

export const TabButtonPill = styled.button<{ active: boolean }>`
  flex: 1;
  padding: 8px;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  background: ${({ active, theme }) => (active ? theme.primary1 : 'transparent')};
  color: ${({ active, theme }) => (active ? '#fff' : theme.text2)};

  &:hover {
    opacity: 0.8;
  }
`

/** antd 风格：订单簿/我的订单/管理合约 - 横向标签 + 底部分割线 + 底部指示条 */
export const TabRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
  margin-bottom: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.bg3};
`

export const TabButton = styled.button<{ active: boolean }>`
  flex: none;
  padding: 12px 16px;
  margin-bottom: -1px;
  border: none;
  border-bottom: 2px solid ${({ active, theme }) => (active ? theme.primary1 : 'transparent')};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.2s, border-color 0.2s;
  background: transparent;
  color: ${({ active, theme }) => (active ? theme.primary1 : theme.text2)};

  &:hover {
    color: ${({ active, theme }) => (active ? theme.primary1 : theme.text1)};
  }
`

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
  font-size: 13px;
`

export const InfoLabel = styled.span`
  color: ${({ theme }) => theme.text2};
`

export const InfoValue = styled.span`
  color: ${({ theme }) => theme.text1};
  font-weight: 500;
`

export const PriceHighlight = styled.span`
  color: ${({ theme }) => theme.primary1};
  font-weight: 600;
`

export const Divider = styled.div`
  height: 1px;
  background: ${({ theme }) => theme.bg3};
  margin: 8px 0;
`

/** 手续费率行：左侧文案，右侧为具体数字 + 更换图标（无输入框感） */
export const FeeRateRow = styled(RowBetween)`
  padding: 0.4rem 0;
  margin-bottom: 6px;
`

export const FeeRateRight = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.text2};
`

export const FeeRateChangeBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  color: ${({ theme }) => theme.text2};

  :hover {
    background: ${({ theme }) => theme.bg2};
    color: ${({ theme }) => theme.text1};
  }
`

export const OrderCardWrapper = styled.div`
  background: ${({ theme }) => theme.bg2};
  border-radius: 10px;
  padding: 10px 12px;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const OrderCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
`

export const CardHeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const CardIconBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border: none;
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
  color: ${({ theme }) => theme.text2};

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.bg3};
    color: ${({ theme }) => theme.text1};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const OrderTypeBadge = styled.span<{ isBuy: boolean }>`
  background: ${({ isBuy, theme }) => (isBuy ? theme.green1 : theme.red1)};
  color: #fff;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
`

/** 0=OPEN 挂单中(蓝), 1=FILLED 全部成交(绿), 2=CANCELLED 已取消 */
export const StatusBadge = styled.span<{ status: number }>`
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  background: ${({ status, theme }) => {
    switch (status) {
      case 0:
        return 'rgba(24, 144, 255, 0.2)'
      case 1:
        return theme.green1 + '20'
      case 2:
        return theme.text3 + '20'
      default:
        return theme.bg3
    }
  }};
  color: ${({ status, theme }) => {
    switch (status) {
      case 0:
        return '#1890ff'
      case 1:
        return theme.green1
      case 2:
        return theme.text3
      default:
        return theme.text2
    }
  }};
`

export const ProgressBar = styled.div`
  width: 100%;
  height: 3px;
  background: ${({ theme }) => theme.bg3};
  border-radius: 2px;
  margin: 6px 0;
  overflow: hidden;
`

export const ProgressFill = styled.div<{ percent: number }>`
  width: ${({ percent }) => percent}%;
  height: 100%;
  background: ${({ theme }) => theme.primary1};
  border-radius: 2px;
  transition: width 0.3s;
`

export const ActionButtonRow = styled.div`
  display: flex;
  gap: 6px;
  margin-top: 6px;
`

/** 与流动性「更新年化」一致的 ButtonSecondary 风格 */
export const SmallButton = styled.button<{ variant?: 'danger' | 'primary' }>`
  flex: 1;
  padding: 8px 12px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  background-color: ${({ variant, theme }) => (variant === 'danger' ? theme.red1 : theme.primary5)};
  color: ${({ variant, theme }) => (variant === 'danger' ? 'white' : theme.primaryText1)};

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
`

export const ToggleLabel = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.text2};
`

export const ToggleSwitch = styled.button<{ active: boolean }>`
  width: 40px;
  height: 22px;
  border-radius: 11px;
  border: none;
  cursor: pointer;
  position: relative;
  background: ${({ active, theme }) => (active ? theme.primary1 : theme.bg3)};
  transition: background 0.2s;

  &::after {
    content: '';
    position: absolute;
    top: 2px;
    left: ${({ active }) => (active ? '20px' : '2px')};
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: white;
    transition: left 0.2s;
  }
`

export const SectionTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.text1};
  margin: 12px 0 8px;
`

export const EmptyState = styled.div`
  text-align: center;
  padding: 24px 16px;
  color: ${({ theme }) => theme.text3};
  font-size: 13px;
`

// 数量/交易额 百分比进度条
export const AmountPercentSliderWrap = styled.div`
  padding: 10px 0 6px;
`

export const AmountPercentSlider = styled.input.attrs({ type: 'range', min: 0, max: 100, step: 1 })`
  width: 100%;
  height: 6px;
  border-radius: 3px;
  accent-color: ${({ theme }) => theme.primary1};
  cursor: pointer;
`

export const AmountPercentLabels = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
  font-size: 11px;
  color: ${({ theme }) => theme.text2};
  & > span {
    cursor: pointer;
    user-select: none;
  }
  & > span:hover {
    color: ${({ theme }) => theme.text1};
  }
`

export const AmountPercentValue = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.primary1};
`
